import { get_weeks_in_month as e } from "./get_weeks_in_month.js";
import { get_normalized_date as t } from "./get_normalized_date.js";
import { get_day_info as n } from "./get_day_info.js";
import { previous_month_days as r } from "./previous_month_days.js";
import { previous_month as i } from "./previous_month.js";
import { get_number_of_days_in_BS_month as a } from "./get_number_of_days_in_BS_month.js";
import { previous_year as o } from "./previous_year.js";
import { is_date_valid as s } from "./is_date_valid.js";
// src/design/forms/datepicker/calendar-engine/use-cases/nepali_date/index.ts
var c = {
	get_eng_day_info: void 0,
	get_first_day_of_the_month: void 0,
	get_next_decade_date: void 0,
	get_next_month_date: void 0,
	get_next_year_date: void 0,
	get_previous_decade_date: void 0,
	get_previous_month_date: void 0,
	get_previous_year_date: void 0,
	get_total_days_in_month: void 0,
	is_today: void 0,
	get_day_info: n,
	get_normalized_date: t,
	get_number_of_days_in_BS_month: a,
	get_weeks_in_month: e,
	previous_month: i,
	previous_month_days: r,
	previous_year: o,
	is_date_valid: s,
	validate_date_in_range: () => {}
};
export { c as NEPALI_DATE };

//# sourceMappingURL=index.js.map